import React, { lazy, useEffect, useState } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./App.css";
import "../src/assets/css/sports.css"
import "../src/assets/css/style.css";
import "../src/assets/css/sky.css";

import "../src/assets/css/loginheader.css";
import "../src/assets/css/media.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/assets/css/style09.css";
import "../src/assets/css/theme.css"

import logo from "./assets/images/logo.png";
import ReactPlayer from "react-player";

import BalanceOverview from "./pages/BalanceOverview";
import Logs from "./pages/Logs";
import BetsHistory from "./pages/BetsHistory";
import ProfitLoss from "./pages/ProfitLoss";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import CurrentBets from "./pages/CurrentBets/CurrentBets";
import LoginNew from "./Auth2/Login";
import Register from "./Auth2/Registration";

import AccountStatement from "./pages/AccountStatement";
import Otp from "./Auth2/Otp";
import CreatePin from "./Auth2/CreatePin";
// const HomeNew = lazy(() => import('./pages/HomeNew'))
// const Deposit = lazy(() => import('./pages/Deposit'))
// const WithDraw = lazy(() => import('./pages/WithDraw'))
// const AfiliateLink = lazy(() => import('./pages/AfiliateLink'))
// const Afiliates = lazy(() => import('./pages/Afiliates'))
// const DepositHistory = lazy(() => import('./pages/DepositHistory'))
// const WithdrawHistory = lazy(() => import('./pages/WithdrawHistory'))
// const Promotions = lazy(() => import('./pages/Promotions'))
// const MyAccount = lazy(() => import('./pages/MyAccount'))
// const ChangePassword = lazy(() => import('./Auth2/ChangePassword'))
// const ForgotPassword = lazy(() => import('./Auth2/ForgotPassword'))
// const Turnover = lazy(() => import('./pages/Turnover'))
// const Casino = lazy(() => import('./pages/casino/Casino'))
// const Inplay = lazy(() => import('./pages/Inplay/Inplay'))
// const Today = lazy(() => import('./pages/Today'))
// const Tomorrow = lazy(() => import('./pages/Tomorrow'))
// const Result = lazy(() => import('./pages/Result'))
// const MultiMarket = lazy(() => import('./pages/MultiMarket/Multimarket'))
// const Sports = lazy(() => import('./pages/Sports'))
import HomeNew from "./pages/HomeNew";
import Deposit from "./pages/Deposit";
import WithDraw from "./pages/WithDraw";
import AfiliateLink from "./pages/AfiliateLink";
import Afiliates from "./pages/Afiliates";

import DepositHistory from "./pages/DepositHistory";
import WithdrawHistory from "./pages/WithdrawHistory";
import Promotions from "./pages/Promotions";
import MyAccount from "./pages/MyAccount";
import ChangePassword from "./Auth2/ChangePassword";
import ForgotPassword from "./Auth2/ForgotPassword";
import Refer from "./pages/Refer";
import Turnover from "./pages/Turnover";
import Casino from "./pages/casino/Casino";
import Inplay from "./pages/Inplay/Inplay";
import Today from "./pages/Today";
import Tomorrow from "./pages/Tomorrow";
import Result from "./pages/Result";
import Profile from "./pages/Profile";
import MultiMarket from "./pages/MultiMarket/Multimarket";
import Sports from "./pages/Sports";
import SportsDetail from "./pages/SportsDetail";
import BidDetail from "./pages/MatchDetails/BidDetail";
import {
  ProtectedRoute,
  ProtectedRouteLogin,
} from "./components/ProctectedRoute";
import NewProfile from "./pages/NewProfile";
import AllOverlay from "./components/All_overlay";
import ReferNew from "./pages/ReferNew";
import LoadingPage from "./components/loader/LoadingPage";
import FreeSpin from "./pages/FreeSpin";

const AppWithOverlays = () => {
  return (
    <>
      <AllOverlay />
      <Outlet />
    </>
  );
};

const routerList = createBrowserRouter(
  createRoutesFromElements(
      <Route
        element={
          <AuthProvider>
            <BetSlipProvider>
              <AppWithOverlays />
            </BetSlipProvider>
          </AuthProvider>
        }
      >
        {/* Global overlay components rendered here via AppWithOverlays */}

        <Route path="/" element={<HomeNew />} />
        <Route path="/exchange" element={<HomeNew />} />
        <Route path="/exchange/userhome" element={<HomeNew />} />
        <Route path="/pin" element={<CreatePin />} />
        {/* <Route path="/deposit" element={<Deposit />} />
        <Route path="/withdraw" element={<WithDraw />} />
        <Route path="/myaccount" element={<MyAccount />} /> */}
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/login" element={<LoginNew />} />
        <Route path="/register" element={<Register />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/affilate" element={<AfiliateLink />} />
        <Route path="/affilates" element={<Afiliates />} />
        <Route path="/balance-overview" element={<BalanceOverview />} />
        <Route path="/current-bets" element={<CurrentBets />} />
        <Route path="/active-log" element={<Logs />} />
        <Route path="/my-profile" element={<Profile />} />
        <Route path="/bets-history" element={<BetsHistory />} />
        <Route path="/account-statement" element={<AccountStatement />} />
        <Route path="/profit-and-loss" element={<ProfitLoss />} />
        <Route path="/deposit-history" element={<DepositHistory />} />
        <Route path="/withdraw-history" element={<WithdrawHistory />} />
        {/* <Route path="/refer" element={<Refer />} /> */}
        <Route path="/refer" element={<ReferNew />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/turnover" element={<Turnover />} />
        <Route path="/casino" element={<Casino />} />

        <Route path="/inplay" element={<Inplay />}></Route>
        <Route path="/today" element={<Today />}></Route>
        <Route path="/tomorrow" element={<Tomorrow />}></Route>
        <Route path="/result" element={<Result />}></Route>
        <Route path="/profile" element={<Profile />}></Route>
        <Route path="/multiMarket" element={<MultiMarket />}></Route>
        <Route path="/sports" element={<Sports />}></Route>
        <Route path="/sportsdetail" element={<SportsDetail />}></Route>
        <Route path="/spin-wheel" element={<FreeSpin />} />

        <Route
          exact
          path="/match-details/:eventId/:marketId"
          element={<BidDetail />}
        ></Route>

        <Route path="/new-profile" element={<NewProfile />} />
        <Route
          path="/deposit"
          element={
            <ProtectedRoute>
              <Deposit />
            </ProtectedRoute>
          }
        />{" "}
        <Route
          path="/deposit/:offerCode"
          element={
            <ProtectedRoute>
              <Deposit />
            </ProtectedRoute>
          }
          exact
        />
        <Route
          path="/withdraw"
          element={
            <ProtectedRoute>
              <WithDraw />
            </ProtectedRoute>
          }
        />
        <Route
          path="/myaccount"
          element={
            <ProtectedRoute>
              <MyAccount />
            </ProtectedRoute>
          }
        />{" "}
      </Route>
  )
);

const App = () => {
  return  (
      <>
      {/* <LoadingPage /> */}
      <RouterProvider router={routerList}  fallbackElement={<LoadingPage />}/>
      </>
  )
};

export default App;
